export const ICSActionIcon = (props: {
  column?
  data?
  icon: string
  title: string
  onClick?
  renderData
  disabled?: boolean
}) => {
  const { icon, title, onClick, disabled } = props

  const classes = `dx-link dx-icon-${icon} dx-link-icon ics-action-icon ${
    disabled ? 'disabled' : ''
  }`
  return <i className={classes} title={title} onClick={onClick}></i>
}
